import { useBrandingContext } from '@group-link-one/gl-components';
import { Outlet } from 'react-router-dom';
import { useMainLayout } from './useMainLayout';
import { type IBranding } from '@/Branding/_Types/Branding.types';
import { env } from '@/env';
import { GlobalErrorBoundary } from '@/Errors/GlobalErrorBoundary/GlobalErrorBoundary';
import { MainTemplate } from '@/Templates/Main/Main.template';
import { PageLayoutRight } from '@/Templates/Main/PageLayout/PageLayoutRight';

export const MainLayout = () => {
  const { customLocale, navListTop, navListBottom, profileMenuOptions, getTopbarAddonsItems } =
    useMainLayout();

  const { brandingData } = useBrandingContext() as { brandingData: IBranding };

  return (
    <MainTemplate
      sidebarOptions={{
        logo: {
          dark: brandingData.Onboard.logo_dark,
          light: brandingData.Onboard.logo,
          clipPathValue: '81',
          leftPosition: 7,
        },
        topItems: navListTop,
        bottomItems: navListBottom,
      }}
    >
      <PageLayoutRight
        footerText='Group Link One'
        topbarOptions={{
          rightItems: [],
          addonItems: getTopbarAddonsItems(),
        }}
        profileMenuOptions={profileMenuOptions}
      >
        <GlobalErrorBoundary
          texts={{
            title: customLocale('globalErrorBoundary.title', ''),
            description: customLocale('globalErrorBoundary.description', ''),
            contactSupport: customLocale('globalErrorBoundary.contactSupport', ''),
            tryAgain: customLocale('globalErrorBoundary.tryAgain', ''),
          }}
          image={`${env.VITE_CDN_URL}/Utilities/Water/fallback-error.svg`}
        >
          <Outlet />
        </GlobalErrorBoundary>
      </PageLayoutRight>
    </MainTemplate>
  );
};
